var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.576,
    height: 140,
    rx: 70,
    fill: "#F3E3E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_6162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.25 106.25V43.75C51.25 42.3693 52.3693 41.25 53.75 41.25H66.875",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6251 41.25H102.5C103.881 41.25 105 42.3693 105 43.75V103.159C105 104.526 103.901 105.64 102.534 105.658L58.7501 106.25",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8751 87.5H98.7501M76.8751 74.375H98.7501M76.8751 61.25H98.7501M78.7501 31.25C76.6514 31.25 75.2461 32.8813 74.4484 34.4321C73.9237 35.4522 72.9454 36.25 71.7982 36.25H70.0001C68.6194 36.25 67.5001 37.3693 67.5001 38.75V43.125C67.5001 44.5057 68.6194 45.625 70.0001 45.625H88.1251C89.5058 45.625 90.6251 44.5057 90.6251 43.125V38.75C90.6251 37.3693 89.5058 36.25 88.1251 36.25H85.7021C84.5549 36.25 83.5766 35.4522 83.0519 34.4321C82.2542 32.8813 80.8488 31.25 78.7501 31.25ZM58.7501 58.75L62.6074 62.6072C63.5837 63.5835 65.1666 63.5835 66.1429 62.6072L72.5001 56.25L66.1429 62.6072C65.1666 63.5835 63.5837 63.5835 62.6074 62.6072L58.7501 58.75Z",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.375 85.625L63.2322 89.4822C64.2085 90.4585 65.7915 90.4585 66.7678 89.4822L73.125 83.125",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.375 71.875L63.2322 75.7322C64.2085 76.7085 65.7915 76.7085 66.7678 75.7322L73.125 69.375",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_6162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.5758,
    height: 80,
    fill: "white",
    transform: "translate(40 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.e9f35194b06d3cfd736dcfcdfa1ffb02.svg";
export { ForwardRef as ReactComponent };